// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"720f787c25783b969c12","883":"90ba036f9a0f40d51a87"}[chunkId] + ".js";
};